import React from "react";
import DOMPurify from "dompurify";

const OverviewSection = ({ data }) => {
  // Data validation
  if (!data?.overview_section) return null;

  const { overview_heading, overview_content } = data.overview_section;

  return (
    <section className="sky-ws-content-section sky-ov-section">
      <div className="container">
        {/* Heading: Pixel perfect centered as per image */}
        {overview_heading && (
          <h2 className="sky-ov-heading mb-2 ">{overview_heading}</h2>
        )}

        {/* Content Area: Max-width applied for better readability */}
        <div className="sky-ov-content-wrapper">
          {overview_content && (
            <div
              className="sky-ov-text text-center"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(overview_content),
              }}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
